import { render } from "./AuthChallengeRetention.vue?vue&type=template&id=4f527500&ts=true"
import script from "./AuthChallengeRetention.vue?vue&type=script&lang=ts"
export * from "./AuthChallengeRetention.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__